import { render, staticRenderFns } from "./infoSetPinCodePage.vue?vue&type=template&id=6ecaa0e2&scoped=true&"
import script from "./infoSetPinCodePage.vue?vue&type=script&lang=js&"
export * from "./infoSetPinCodePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecaa0e2",
  null
  
)

export default component.exports